var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if( url ) { 
__p+='\n<a href="'+
((__t=( url ))==null?'':_.escape(__t))+
'" class="qa-profilepicture">\n  <div class="profilepicture">\n    ';
 if(isDefaultAvatar) { 
__p+='\n    <div class="default-avatar '+
((__t=( generatedAvatarClass ))==null?'':_.escape(__t))+
'">\n      '+
((__t=( avatarInital ))==null?'':_.escape(__t))+
'\n    </div>\n    ';
 }else{ 
__p+='\n      <img src="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" alt="'+
((__t=( name ))==null?'':_.escape(__t))+
'" />\n    ';
 } 
__p+='\n  </div>\n  ';
 if (showRank && typeof rank != 'undefined' && rank.avatarIconUrl) { 
__p+='\n    <div class="profilelabel">\n      <img src="'+
((__t=( rank.avatarIconUrl ))==null?'':_.escape(__t))+
'" title="'+
((__t=( rank.name ))==null?'':_.escape(__t))+
'" alt="'+
((__t=( rank.name ))==null?'':_.escape(__t))+
'" />\n    </div>\n  ';
 } 
__p+='\n</a>\n';
 } else {
__p+='\n<div class="default-cursor qa-profilepicture">\n  <div class="profilepicture">\n    <div class="default-avatar '+
((__t=( generatedAvatarClass ))==null?'':_.escape(__t))+
'">\n      '+
((__t=( avatarInital ))==null?'':_.escape(__t))+
'\n    </div>\n  </div>\n</div>\n';
 } 
__p+='\n';
}
return __p;
};
